<template>
    <v-app class="pagina">
        <div class="viewPagina">
            <Aluguel></Aluguel>
        </div>
    </v-app>
</template>
<script>
import Aluguel from './components/Aluguel.vue';
export default {
    data: () => ({}),
    components: {
        Aluguel
    }
};
</script>
